module.exports = __webpack_public_path__ + "media/mangel.afa936e4.ogg";